import { Divider, Empty, Space, Spin } from 'antd';
import axios, { AxiosResponse } from 'axios';
import useAPI from 'hooks/useAPI';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { INewsItem, INewsItemDetail } from 'types/news';

import styles from './AnnouncementDetailCard.module.css';
import classNames from 'classnames/bind';

import dayjs from 'dayjs';
import DOMPurify from 'dompurify';

import { LoadingOutlined } from '@ant-design/icons';
import GoToBackButton from 'components/common/GotoBackButton';
import NewsSectionTab from '../NewsSectionTab';

const cx = classNames.bind(styles);

function AnnouncementDetailCard() {
  const router = useRouter();
  const { id, page } = router.query;

  const sanitizer = DOMPurify.sanitize;

  const getAnnouncementDetail = useCallback(async () => {
    const announcementData: AxiosResponse<INewsItemDetail> = await axios.get(
      `/api/announcements/${id}?populate=*`
    );
    return announcementData;
  }, [id]);

  const { data, isLoading, isError, error } = useAPI<INewsItem>(
    getAnnouncementDetail
  );

  const handleGotoListPage = () =>
    router.push(`/news/announcement?page=${page || 1}`);

  const renderer = () => {
    if (isLoading) {
      return (
        <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
      );
    }
    if (isError) {
      if (error?.code === 'ERR_BAD_REQUEST') {
        return (
          <Empty description="잘못된 요청이거나, 해당 공고가 존재하지 않아요." />
        );
      }
      /* TODO: 에러 화면 정리 */
      return (
        <Empty description="해당 공고를 불러오는데 문제가 발생했어요. 다시 시도해주세요." />
      );
    }
    if (!!data?.data) {
      const { title, displayDate, content } = data.data.attributes;
      return (
        <div className={cx('wrapper')}>
          <section className={cx('header')}>
            <h1 className={cx('title')}>{title}</h1>
            <span className={cx('date')}>
              {dayjs(displayDate).format('YYYY.MM.DD')}
            </span>
          </section>
          <Divider />
          <section className={cx('content-wrapper')}>
            <p
              dangerouslySetInnerHTML={{
                __html: sanitizer(content || '등록된 콘텐츠 내용이 없습니다.'),
              }}
            />
          </section>
          <GoToBackButton onClick={handleGotoListPage} />
        </div>
      );
    }
    return (
      /* TODO: 빈 화면 정리 */
      <Empty description="해당 보도자료가 존재하지 않아요." />
    );
  };
  return (
    <Space
      direction="vertical"
      size="middle"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <NewsSectionTab />
      {renderer()}
    </Space>
  );
}

export default AnnouncementDetailCard;
